import _ from 'underscore'
export default {
  state: {
    createTemplateData: {},
    orgCreateTemplateData: {},
    setupTemplateData: {},
    orgSetupTemplateData: {},
    steps: [],
    formData: [],
    currentStep: 0,
    innerCurrentStep: 0,
    currentStepTitle: '',
    showUserId: false,
    customerType: 'API_APP',
    selectedForm: [],
    selectedFormId: '',
    selectedDevAuthTypes: [],
    actionData: [],
    disclaimerData: [],
    subbrandDataChanged: false,
    channelBrandConfig: {}
  },
  mutations: {
    formDataConstruct: state => {
      state.selectedForm = []
      state.actionData = []
      state.disclaimerData = []
      let selectedAuthType = []
      state.createTemplateData.content.forEach(content => {
        if (content.stepOrder == state.currentStep) {
          state.selectedForm = content.form
          state.actionData = content.actions
          state.disclaimerData = content.disclaimers
          state.selectedFormId = content.stepId
          if (content.stepId == 'prodAppSelection') {
            toggleAppSection(content);
          }
          else if (content.stepId == 'contactDetails') {
            updateUserIdShowHide(content);
            updateContactMember2ShowHide(content);
          } else if (
            content.stepId == 'authStageSetup' ||
            content.stepId == 'authProdSetup'
          ) {

            if (content.stepId == 'authProdSetup') {
              var prodAuthType = _.findWhere(content.form, {
                refId: 'prodAuthType'
              });
              if (typeof state.selectedDevAuthTypes !== 'undefined' && state.selectedDevAuthTypes.length > 0) {
                prodAuthType.defaultValue = state.selectedDevAuthTypes;
              }
            }

            updateAuthTypeFormShowHide(content);
            updateJWT2ShowHide(content)

            if (content.stepId == 'authStageSetup') {
              jwtIssuerIdCheck(content);
            } else {
              jwtProdIssuerIdCheck(content);
            }
          }
        }

      })
      console.log('Selected Form Data--->', state.selectedForm)

      setTimeout(function () {
        state.subbrandDataChanged = false
      }, 200)

      function toggleAppSection(prodAndAppContent) {
        state.createTemplateData.content.forEach(content => {
          if (content.stepId == 'generalConfig') {
            content.form.forEach(formData => {
              if (formData.refId == 'customerType') {
                state.customerType = formData.defaultValue
              }
            })
          }
        })
        prodAndAppContent.form.forEach(form => {
          if (form.groupName == 'AppGroup') {
              if(form.show) {
                form.show = state.customerType == 'API_APP' ? true : false
              } 
          }
        })
      }

      function updateUserIdShowHide(contactsContent) {
        state.createTemplateData.content.forEach(content => {
          if (content.stepId == 'generalConfig') {
            let tier1 = _.findWhere(content.form, {
              refId: 'tier1CustomerCare'
            })
            if (tier1 && tier1.defaultValue == 'SUBBRAND') {
              state.showUserId = true
            } else {
              state.showUserId = false
            }
          }
        })
        contactsContent.form.forEach(form => {
          if (form.controlName == 'formGroup') {
            form.formData.forEach(formData => {
              if (formData.refId == 'cUserId' ||
                formData.refId == 'cUserId1' ||
                formData.refId == 'resetUserIdPwd' ||
                formData.refId == 'resetUserIdPwd1') {
                formData.show = state.showUserId
              }
            })
          }
        })
      }

      function updateAuthTypeFormShowHide(authSetupContent) {
        authSetupContent.form.forEach(form => {
          if (form.refId == 'stageAuthType' || form.refId == 'prodAuthType') {
            selectedAuthType = form.defaultValue
          }
          if (form.controlName == 'formGroup') {
            if (selectedAuthType.indexOf(form.refId) >= 0) {
              form.show = true
              if (form.refId == 'jwt') {
                state.showAddAnotherJWTBtn = true
                state.showJWT2 = true
              }
            } else {
              form.show = false
              if (form.refId == 'jwt') {
                state.showJWT2 = false
                state.showAddAnotherJWTBtn = false
              }
            }
          }
          if (
            (form.refId &&
              form.refId == 'addAnotherJWTBtn') || (form.refId &&
                form.refId == 'addAnotherProdJWT')) {
            form.show = state.showAddAnotherJWTBtn
          }
        })
      }

      function updateContactMember2ShowHide(contactsContent) {
        contactsContent.form.forEach(form => {
          if (form.controlName == 'formGroup' && form.refId == 'contact2') {
            var formDataObj = form.formData
            for (let i = 0; i <= formDataObj.length; i++) {
              if (formDataObj[i].show !== false) {
                if (formDataObj[i].defaultValue !== '') {
                  form.show = true
                  state.disableAddAnotherContactBtn = true
                  break;
                } else {
                  form.show = false
                  state.disableAddAnotherContactBtn = false
                  break;
                }
              }
              if (formDataObj[i].refId === 'resetUserIdPwd1') {
                if (formDataObj[i].defaultValue !== false) {
                  formDataObj[i].show = true
                } else {
                  formDataObj[i].show = false
                }
              }
            }
          }
          if (
            form.refId &&
            form.refId == 'addAnotherContactBtn'
          ) {
            form.disabled = state.disableAddAnotherContactBtn
          }
        })
      }

      function updateJWT2ShowHide(authSetupContent) {
        authSetupContent.form.forEach(form => {
          if ((form.controlName == 'formGroup' && form.refId == 'jwt2') ||
            form.controlName == 'formGroup' && form.refId == 'jwtprod2') {
            if (state.showJWT2) {
              form.inlineIconBtn.show = true
              form.formData.forEach(formData => {
                if (formData.show !== false) {
                  if (formData.defaultValue !== '') {
                    form.show = true
                    state.disableAddAnotherJWTBtn = true
                  } else {
                    form.show = false
                    state.disableAddAnotherJWTBtn = false
                  }
                }
              })
            }
          }

          if (
            (form.refId &&
              form.refId == 'addAnotherJWTBtn') ||
            form.refId &&
            form.refId == 'addAnotherProdJWT') {
            form.disabled = state.disableAddAnotherJWTBtn
          }
        })
      }

      function jwtIssuerIdCheck(authSetupContent) {
        state.createTemplateData.content.forEach(content => {
          if (content.stepId == 'authStageSetup') {
            content.form.forEach(formData => {
              if (formData.refId == 'jwt') {
                var formDataObj = formData.formData
                for (let i = 0; i <= formDataObj.length; i++) {
                  if (formDataObj[i].refId === 'jwtIssuerId' &&
                    formDataObj[i].defaultValue !== '') {
                    state.showOtherFields = false;
                    break;
                  } else {
                    state.showOtherFields = true;
                    break;
                  }
                }
              }

              if (formData.refId == 'jwt2') {

                var formDataObj = formData.formData
                for (let i = 0; i <= formDataObj.length; i++) {
                  if (formDataObj[i].refId === 'jwtIssuerId1' &&
                    formDataObj[i].defaultValue !== '') {
                    state.showOtherFields1 = false;
                    break;
                  } else {
                    state.showOtherFields1 = true;
                    break;
                  }
                }
              }

            })
          }
        })
        authSetupContent.form.forEach(form => {
          if (form.refId === 'jwt') {
            form.formData.forEach(formData => {
              if (formData.refId == 'maxExpTime' || formData.refId == 'jwtPublicKey') {
                formData.show = state.showOtherFields
              }
            })
          }
          if (form.refId === 'jwt2') {
            form.inlineIconBtn.show = state.showOtherFields1
            form.formData.forEach(formData => {
              if (formData.refId == 'maxExpTime1' || formData.refId == 'jwtPublicKey1') {
                formData.show = state.showOtherFields1
              }
            })
          }
        })
      }

      function jwtProdIssuerIdCheck(authSetupContent) {
        state.createTemplateData.content.forEach(content => {
          if (content.stepId == 'authProdSetup') {
            content.form.forEach(formData => {
              if (formData.refId == 'jwt') {
                var formDataObj = formData.formData
                for (let i = 0; i <= formDataObj.length; i++) {
                  if (formDataObj[i].refId === 'jwtProdIssuerId' &&
                    formDataObj[i].defaultValue !== '') {
                    state.showProdOtherFields = false;
                    break;
                  } else {
                    state.showProdOtherFields = true;
                    break;
                  }
                }
              }

              if (formData.refId == 'jwtprod2') {
                var formDataObj = formData.formData
                for (let i = 0; i <= formDataObj.length; i++) {
                  if (formDataObj[i].refId === 'jwtProdIssuerId1' &&
                    formDataObj[i].defaultValue !== '') {
                    state.showProdOtherFields1 = false;
                    break;
                  } else {
                    state.showProdOtherFields1 = true;
                    break;
                  }
                }
              }

            })
          }
        })
        authSetupContent.form.forEach(form => {
          if (form.refId === 'jwt') {
            form.formData.forEach(formData => {
              if (formData.refId == 'maxExpTimeProd' || formData.refId == 'jwtProdPublicKey') {
                formData.show = state.showProdOtherFields
              }
            })
          }
          if (form.refId === 'jwtprod2') {
            form.inlineIconBtn.show = state.showProdOtherFields1
            form.formData.forEach(formData => {
              if (formData.refId == 'maxExpTimeProd1' || formData.refId == 'jwtProdPublicKey1') {
                formData.show = state.showProdOtherFields1
              }
            })
          }
        })
      }
    }
  },

  actions: {
    formDataConstruct: (context, payload) => {
      context.commit('formDataConstruct', payload)
    }
  }
}